import { put, takeEvery } from "redux-saga/effects"
import { fetchGraphMethod } from "../../../services/httpService"
import messagePopup from "../../../utils/messagePopup"

// ========================================== Action Type =====================================================
export const actionType = {
    BATTING_PREFERENCE_LIST_START: 'BATTING_PREFERENCE_LIST_START',
    BATTING_PREFERENCE_LIST_SUCCESS: 'BATTING_PREFERENCE_LIST_SUCCESS',
    BATTING_PREFERENCE_LIST_FAILED: 'BATTING_PREFERENCE_LIST_FAILED'
}

// ============================================ Actions ========================================================
export const battingPreferenceListStart = (data) => ({
   type: actionType.BATTING_PREFERENCE_LIST_START,
   payload: data
})

export const battingPreferenceListSuccess = (data) => ({
    type: actionType.BATTING_PREFERENCE_LIST_SUCCESS,
    payload: data
})

export const battingPreferenceListFailed = (data) => ({
    type: actionType.BATTING_PREFERENCE_LIST_FAILED,
    payload: data
})

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null
}

export default function battingPreferenceListReducer(state = INIT_STATE,action){
  switch(action.type){
      case actionType.BATTING_PREFERENCE_LIST_START: 
        return {
            ...state,
            loading: true
        }
      case actionType.BATTING_PREFERENCE_LIST_SUCCESS:
        return {
            ...state,
            loading: false,
            data: action.payload,
            error: null
        }  
      case actionType.BATTING_PREFERENCE_LIST_FAILED:
        return {
            ...state,
            loading: false,
            data: null,
            error: action.payload
        }       
      default: return {...state}  
  }
} 

// ===================================================== side effect =============================================

export function* battingPreferenceListSaga(action){
   try {
    const response = yield fetchGraphMethod(action.payload.query,action.payload.variables,true);
    if(response && response.status === 200){
       const allBattingpreferences = response.data.data.allBattingpreferences.Battingpreferences ? response.data.data.allBattingpreferences.Battingpreferences : null
       yield put(battingPreferenceListSuccess(allBattingpreferences));
    } else {
      messagePopup('','Batting Preference List failed','error')   
      yield put(battingPreferenceListFailed('Batting Preference List failed')) 
    }
   } catch (error) {
     messagePopup('','Batting Preference List failed','error')   
     yield put(battingPreferenceListFailed('Batting Preference List failed')) 
   }
}

export function* watchBattingPreferenceListSaga(){
    yield takeEvery(actionType.BATTING_PREFERENCE_LIST_START, battingPreferenceListSaga)
}